import styled from 'styled-components'

interface PrimaryButtonType {
  color: string;
  maxWidth?: boolean | null | undefined;
}

const _PrimaryButton = styled.button<PrimaryButtonType>;


export default _PrimaryButton`
  background: ${props => props.color};
  border: 1px solid ${props => props.color};
  border-radius: 30px;
  box-shadow: rgba(0, 0, 0, 0.1) 1px 2px 4px;
  box-sizing: border-box;
  color: #FFFFFF;
  cursor: pointer;
  display: inline-block;
  font-family: nunito,roboto,proxima-nova,"proxima nova",sans-serif;
  font-size: 16px;
  font-weight: 800;
  line-height: 4px;
  min-height: 40px;
  outline: 0;
  padding: 28px 14px;
  text-align: center;
  text-rendering: geometricprecision;
  text-transform: none;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: middle;

  ${props => props.maxWidth ? "width: 100%;" : ""}

  &:hover,
  &:active {
    background-color: initial;
    background-position: 0 0;
    color: ${props => props.color};
  }

  &:active {
    opacity: .5;
  }

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }
`;